// planetCivRandomizer.js
var PlanetCivRandomizer = pc.createScript('planetCivRandomizer');

PlanetCivRandomizer.attributes.add('animRsrc', {type:'string', title: 'animationName'});
PlanetCivRandomizer.attributes.add('delayT', {type:'number', title: 'maxdelay'});
PlanetCivRandomizer.attributes.add('timeOut', {type:'number', title: 'Timeout'});
PlanetCivRandomizer.attributes.add('target', {type:'entity', title: 'targetEnt'});
PlanetCivRandomizer.attributes.add('stationary', {type:'boolean', default: false});
PlanetCivRandomizer.attributes.add('theDelay', {type:'number', default: 0});
PlanetCivRandomizer.attributes.add('minDelay', {type:'number', default: 0});

// initialize code called once per entity
PlanetCivRandomizer.prototype.initialize = function() {
    this.startDelay = true;
    this.anm = this.animRsrc;
    this.ent = this.entity;
    this.timer = 0;
    this.tmOut = this.timeOut;
    this.dlt = Math.floor(Math.random()*this.delayT);
    this.ent.animation.activate = false;
    this.rot = null;
    this.shipRot = null;
    this.once = false;
};

PlanetCivRandomizer.prototype.handler = function () {
    this.ent.enabled = true;
    this.once = false;
    this.target.animation.activate = true;
    this.target.animation.play(this.animRsrc);
};
PlanetCivRandomizer.prototype.tweenTimer = function(){
    var dl = Math.floor(Math.random()* this.theDelay) + this.minDelay;
    var here = this;
    //console.log('station: ' + this.entity.parent.parent.parent.name +  ' dl: ' + dl);
    if(!this.stationary){
        dl = 0.001;
    }

    this.entity
        .tween(this.entity.getLocalPosition())
        .to(this.entity.getLocalPosition(), 0.01, pc.Linear)
        .on('complete', function(){
        here.handler();
        })
        .delay(dl)
        .start();
};

// update code called every frame
PlanetCivRandomizer.prototype.update = function(dt) {

    if(!this.stationary){
       this.rot = new pc.Vec3(Math.floor(Math.random()*360), Math.floor(Math.random()*360), Math.floor(Math.random()*360));
    } else {
        this.shipRot = new pc.Vec3(180,0,Math.floor(Math.random()*360));
    }
    
    this.timer += dt;
    if(this.startDelay){
        if(this.timer > this.dlt){
        this.startDelay = false;
        this.ent.animation.activate = true;
        this.ent.animation.play(this.anm);
            if(this.stationary){
                this.ent.parent.parent.setLocalEulerAngles(this.shipRot.x, this.shipRot.y, this.shipRot.z);
            }
        }
    }
    if(!this.startDelay){
        if(this.entity.animation.currentTime > this.tmOut){
        this.ent.animation.activate = false;
        if(!this.stationary){
           this.ent.setLocalEulerAngles(this.rot.x, this.rot.y, this.rot.z); 
        } else {
            this.ent.parent.parent.setLocalEulerAngles(this.shipRot.x, this.shipRot.y, this.shipRot.z);
        }
            if(!this.once){
                this.tweenTimer();
                this.ent.enabled = false;
                this.once = true;
            }
        } 
    }
};



// swap method called for script hot-reloading
// inherit your script state here
// PlanetCivRandomizer.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/
// 


